// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JqwD-","colBig":"styles_colBig__Bju24","colSmall":"styles_colSmall__2eync"};